export default __webpack_public_path__ + "static/media/H4008.2.9e8fde2f.mp3";